type PlainObject = Record<string, unknown>;

const isPlainObject = (value: unknown): value is PlainObject =>
  typeof value === 'object' && value !== null && !Array.isArray(value);

// Overlays the form's values on the stored config so sections the form does
// not model survive a save. Arrays are replaced, `undefined` deletes a key.
export function mergeFormConfig(
  stored: unknown,
  form: Record<string, unknown>,
): Record<string, unknown> {
  if (!isPlainObject(stored)) {
    return { ...form };
  }
  const result: PlainObject = { ...stored };
  for (const key of Object.keys(form)) {
    const formValue = form[key];
    if (formValue === undefined) {
      delete result[key];
    } else if (isPlainObject(formValue) && isPlainObject(result[key])) {
      result[key] = mergeFormConfig(result[key], formValue);
    } else {
      result[key] = formValue;
    }
  }
  return result;
}
